import React from 'react'
import MuiTooltip from '@mui/material/Tooltip'

const Tooltip = ({ ...rest }) => (
  <MuiTooltip
    {...rest}
    slotProps={{
      tooltip: {
        sx: {
          '&.MuiTooltip-tooltip': {
            backgroundColor: '#1a1f36',
          },
        },
      },
    }}
  />
)

export default Tooltip
